import { Component, Input } from '@angular/core';
import { IShotGradeSpec } from '../interfaces/shot-grade-spec';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-grade-bar',
    templateUrl: './grade-bar.component.html',
    styleUrls: ['./grade-bar.component.scss'],
    imports: [CommonModule],
})
export class GradeBarComponent {
  @Input()
  public ShotGradeSpec: IShotGradeSpec;

  public get getMarkerPosition(): number {
      if (this.ShotGradeSpec !== null) {          
        return (this.ShotGradeSpec.rawData[3]) * 100;
    } else {
        return 0;
    }
  }

  public get getLeftErrorAreaWidth(): number {
    if (this.ShotGradeSpec !== null) {
      return (this.ShotGradeSpec.rawData[5]) * 100;
    } else {
      return 0;
    }
  }

  public get getRightErrorAreaWidth(): number {
    if (this.ShotGradeSpec !== null) {
        return (this.ShotGradeSpec.rawData[6]) * 100;
    } else {
        return 0;
    }
  }

  public get getLeftCriticalAreaWidth(): number {
    if (this.ShotGradeSpec !== null) {
        return (this.ShotGradeSpec.rawData[4]) * 100;
    } else {
        return 0;
    }
  }

  public get getRightCriticalAreaWidth(): number {
    if (this.ShotGradeSpec !== null) {
        return (this.ShotGradeSpec.rawData[7]) * 100;
    } else {
        return 0;
    }
  }

  public get getMinValue(): number {
    if (this.ShotGradeSpec !== null) {
      return this.ShotGradeSpec.minVal;
    } else {
      return 0;
    }
  }

  public get getMaxValue(): number {
    if (this.ShotGradeSpec !== null) {
      return this.ShotGradeSpec.maxVal;
    } else {
      return 0;
    }
  }

  public get markerState(): 'safe' | 'warning' | 'critical' {
    const pos = this.getMarkerPosition;
    if (pos >= 0 && pos <= 100) {
      return 'safe';
    }
    const overshoot = pos < 0 ? -pos : pos - 100;
    const errorWidth = pos < 0 ? this.getLeftErrorAreaWidth : this.getRightErrorAreaWidth;
    return overshoot <= errorWidth ? 'warning' : 'critical';
  }
}
